import { SingleFieldDynamicFields } from '../singleFieldDynamicFields';
import { FormikProps } from 'formik';
import { Typography } from '@mui/material';
import { SingleDynamicField } from '../../../../../shared/types/assistant';

export const StrategicSummary = ({
    formikStrategicSummary,
}: {
    formikStrategicSummary: FormikProps<{
        [key: string]: SingleDynamicField[];
    }>;
}) => {
    return (
        <SingleFieldDynamicFields
            formik={formikStrategicSummary}
            name="strategicSummary"
            label="Resumen Estratégico (Modelo de Uso en Producción)"
            description="Detalla las reglas y mejores prácticas que deben seguirse al usar el modelo en producción para garantizar una experiencia eficiente y confiable. Define principios clave como la resolución en el primer contacto, el uso de un lenguaje claro y personalizado, y la aplicación de ejemplos simples."
            example={
                <Typography color="text.secondary">
                    ✅ Resuelve en primer contacto.
                </Typography>
            }
            rows={1}
        />
    );
};
